import React from 'react';

const CSS = require('./InputGroup.module.scss');

function InputGroup({ children }) {
  return <div className={CSS.inputGroup}>{children}</div>;
}

export default InputGroup;
